import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/**
 * Преобразует входящую дату/время из UTC в GMT-3
 *
 * @param {string} time - Входящая дата/время в строковом формате.
 *
 */
export const getTimeFromUTCToTimezone = date => {
  if (!date || !dayjs(date)?.isValid()) {
    return null;
  }

  return dayjs(date)?.subtract(3, 'hour');
};
